import apiClient from '../apiClient';
import { GET_ACCOMODATION_ITEM_EXPORT_DATA_URL } from '../apiUrl';

const getExportAccomodationItemApi = () => {
  return apiClient.get(GET_ACCOMODATION_ITEM_EXPORT_DATA_URL);
};

export default getExportAccomodationItemApi;
